<template>
  <fullscreen ref="fullscreen" @change="fullscreenChange" class="fullscreen">
    <!--    <div class="misc-controls">-->
    <!--      <ul class="control-list horizontal-list" v-if="extraButtons.length">-->
    <!--        <li v-for="(extraButton, i) in extraButtons" :key="i">-->
    <!--          <button :title="extraButton.title" v-on:click="extraButton.method()">-->
    <!--            <v-icon medium>{{extraButton.icon}}</v-icon>-->
    <!--          </button>-->
    <!--        </li>-->
    <!--      </ul>-->
    <!--    </div>-->
    <div class="canvas-container" ref="canvasContainer">
      <div class="canvas" ref="dmnCanvas"></div>

      <div class="misc-controls">
        <ul class="control-list horizontal-list" v-if="extraButtons.length">
          <li v-for="(extraButton, i) in extraButtons" :key="i">
            <span class="group pa-1">
              <v-btn
                flat
                icon
                :title="extraButton.title"
                @click="extraButton.method(), (loader = 'loading')"
                :loading="loading"
              >
                <v-icon>{{ extraButton.icon }}</v-icon>
              </v-btn>
            </span>
          </li>
        </ul>
      </div>

      <div class="display-controls">
        <ul
          class="mt-3 control-list"
          v-if="propertiesToggleState || paletteToggleState || minimapToggle"
        >
          <li v-if="propertiesToggleState">
            <button title="Toggle Properties" v-on:click="toggleProperties">
              <v-icon color="#424242" medium>{{ propertiesStateIcon }}</v-icon>
            </button>
          </li>
          <li v-if="propertiesToggleState && paletteToggleState">
            <hr />
          </li>
          <li v-if="paletteToggleState">
            <button title="Toggle Palette" v-on:click="togglePalette">
              <v-icon color="#424242" medium>{{ paletteStateIcon }}</v-icon>
            </button>
          </li>
          <li v-if="paletteToggleState && minimapToggle">
            <hr />
          </li>
          <li v-if="minimapToggle">
            <button title="Toggle MiniMap" v-on:click="toggleMinimap">
              <v-icon color="#424242" medium>{{ minimapStateIcon }}</v-icon>
            </button>
          </li>
        </ul>
        <ul class="mt-3 control-list" v-if="fullScreenToggle">
          <li>
            <button title="Toggle Fullscreen" v-on:click="toggleFullscreen">
              <v-icon color="#424242" medium>{{ fullscreenStateIcon }}</v-icon>
            </button>
          </li>
        </ul>

        <ul class="mt-3 control-list" v-if="zoomResetButton">
          <li>
            <button title="reset zoom" v-on:click="zoomReset">
              <v-icon color="#424242" medium>center_focus_strong</v-icon>
            </button>
          </li>
        </ul>

        <ul class="mt-3 control-list" v-if="zoomInButton || zoomOutButton">
          <li v-if="zoomInButton">
            <button title="zoom in" v-on:click="zoomIn">
              <v-icon color="#424242" medium>zoom_in</v-icon>
            </button>
          </li>
          <li v-if="zoomOutButton && zoomInButton">
            <hr />
          </li>
          <li v-if="zoomOutButton">
            <button title="zoom out" v-on:click="zoomOut">
              <v-icon color="#424242" medium>zoom_out</v-icon>
            </button>
          </li>
        </ul>
      </div>
    </div>
    <div
      v-if="propertiesPanel"
      :class="{ 'properties-panel-hide': propertiesPanelHide }"
      class="properties-panel-parent"
      ref="propertiesPanel"
    ></div>
  </fullscreen>
</template>

<script>
import DmnViewer from 'dmn-js/lib/Viewer' // Todo: Import from dist to reduce size?
import DmnModeler from 'dmn-js/lib/Modeler' // Todo: Check for more info to change the background color
import propertiesPanelModule from 'dmn-js-properties-panel'

import minimapModule from 'diagram-js-minimap'

export default {
  props: {
    dmnXml: {
      type: String,
      default: null
    },
    fullScreenToggle: {
      type: Boolean,
      default: false
    },
    zoomResetButton: {
      type: Boolean,
      default: false
    },
    zoomInButton: {
      type: Boolean,
      default: false
    },
    zoomOutButton: {
      type: Boolean,
      default: false
    },
    propertiesPanel: {
      type: Boolean,
      default: false
    },
    propertiesToggle: {
      type: Boolean,
      default: true
    },
    paletteToggle: {
      type: Boolean,
      default: true
    },
    minimapToggle: {
      type: Boolean,
      default: false
    },
    editable: {
      type: Boolean,
      default: false
    },
    extraButtons: {
      type: Array,
      default() {
        return []
      }
    },
    providerModules: {
      type: Array,
      default() {
        return []
      }
    },
    moddleDescriptors: {
      type: Object,
      default() {
        return {}
      }
    }
  },

  data: function() {
    return {
      dmnCanvas: null,
      canvasContainer: null,
      loading: false,
      loader: null,
      fullscreenStateIcon: 'fullscreen',
      propertiesStateIcon: 'chevron_right',
      paletteStateIcon: 'palette',
      minimapStateIcon: 'layers_clear',
      propertiesToggleState: false,
      paletteToggleState: false,
      propertiesPanelHide: false
    }
  },

  watch: {
    dmnXml() {
      this.generateDiagram()
    },
    loader() {
      const l = this.loader
      this[l] = !this[l]
      setTimeout(() => (this[l] = false), 3000)
      this.loader = null
    }
  },

  computed: {
    propertiesToggleStateCompute() {
      return this.propertiesPanel && this.propertiesToggle
    },
    paletteToggleStateCompute() {
      return this.paletteToggle && this.editable
    }
  },

  methods: {
    generateDiagram: function() {
      this.dmnCanvas.importXML(this.dmnXml, err => {
        if (err) {
          console.log('error rendering', err)
        } else {
          console.log('rendered')
          this.dmnCanvas
            .getActiveViewer()
            .get('zoomScroll')
            .reset()
        }
      })
    },

    zoomReset: function() {
      if (this.zoomResetButton) {
        this.dmnCanvas
          .getActiveViewer()
          .get('zoomScroll')
          .reset()
      }
    },

    zoomIn: function() {
      if (this.zoomInButton) {
        this.dmnCanvas
          .getActiveViewer()
          .get('zoomScroll')
          .stepZoom(1)
      }
    },

    zoomOut: function() {
      if (this.zoomOutButton) {
        this.dmnCanvas
          .getActiveViewer()
          .get('zoomScroll')
          .stepZoom(-1)
      }
    },

    toggleFullscreen: function() {
      if (this.fullScreenToggle) {
        this.$refs.fullscreen.toggle()
      }
    },

    toggleProperties: function() {
      if (this.propertiesToggleState) {
        this.propertiesPanelHide = !this.propertiesPanelHide
        this.propertiesChange(this.propertiesPanelHide)
      }
    },

    togglePalette: function() {
      if (this.paletteToggle) {
        this.dmnCanvas
          .getActiveViewer()
          .get('palette')
          .toggle()
      }
    },

    toggleMinimap: function() {
      if (this.minimapToggle) {
        this.dmnCanvas
          .getActiveViewer()
          .get('minimap')
          .toggle()
        this.minimapChange(this.dmnCanvas.get('minimap').isOpen())
      }
    },

    fullscreenChange: function(isFullscreen) {
      if (isFullscreen) {
        this.fullscreenStateIcon = 'fullscreen_exit'
      } else {
        this.fullscreenStateIcon = 'fullscreen'
      }
    },

    propertiesChange: function(isOpen) {
      if (isOpen) {
        this.propertiesStateIcon = 'menu'
      } else {
        this.propertiesStateIcon = 'chevron_right'
      }
    },

    minimapChange: function(isOpen) {
      if (isOpen) {
        this.minimapStateIcon = 'layers'
      } else {
        this.minimapStateIcon = 'layers_clear'
      }
    },

    getDmnCanvas: function() {
      return this.dmnCanvas
    }
  },

  created: function() {
    this.propertiesToggleState = this.propertiesToggleStateCompute
    this.paletteToggleState = this.paletteToggleStateCompute
  },
  mounted: function() {
    let options = { container: this.$refs.dmnCanvas }
    let drd = {}
    let additionalModules = []
    if (this.propertiesPanel && this.editable) {
      drd.propertiesPanel = { parent: this.$refs.propertiesPanel }
      additionalModules.push(propertiesPanelModule)
      for (let propertiesProvider of this.providerModules) {
        additionalModules.push(propertiesProvider)
      }
    }
    if (this.minimapToggle) {
      additionalModules.push(minimapModule)
    }
    if (additionalModules.length > 0) {
      drd.additionalModules = additionalModules
    }
    if (this.editable) {
      options.moddleExtensions = this.moddleDescriptors
      options.drd = drd
      this.dmnCanvas = new DmnModeler(options)
    } else {
      this.dmnCanvas = new DmnViewer(options)
    }
    this.generateDiagram()
  }
}
</script>

<style scoped>
.fullscreen {
  height: 100%;
  display: flex;
}

.canvas {
  height: 100%;
  width: 100%;
  position: absolute;
}

.canvas-container {
  background: #fafafa;
  height: 100%;
  position: relative;
  flex: 1 1 auto;
}

.misc-controls {
  z-index: 11;
  position: absolute;
  top: 5px;
  left: 50%;
  margin-right: -50%;
  transform: translate(-50%, 0);
}

.display-controls {
  position: absolute;
  top: 0;
  right: 0;
  width: 35px;
}

.control-list {
  background: #f8f8f8;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.3);
  border-radius: 2px;
  padding: 5px;
  list-style: none;
  margin: 0;
}

.control-list button {
  padding: 0;
  outline: none;
  cursor: pointer;
  font-size: 22px;
  line-height: 26px;
  color: #555555;
  background: none;
  border: none;
}

.control-list button:hover {
  color: #333333;
}

.control-list.horizontal-list,
.control-list.horizontal-list li {
  display: inline-block;
}

.control-list.horizontal-list button {
  margin: 0 5px;
}

.properties-panel-parent {
  flex: 0 1 auto;
  background: #f8f8f8;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.3);
  border-radius: 2px;
  padding: 5px;
  position: relative;
  top: 0;
  bottom: 0;
  right: 0;
  width: 260px;
  z-index: 1;
  border-left: 1px solid #ccc;
  overflow: auto;
}

.properties-panel-hide {
  display: none;
}

.properties-panel-parent:empty {
  display: none;
}
</style>

<style>
.djs-minimap:not(.open) {
  display: none !important;
}

.djs-minimap .toggle {
  display: none !important;
}

.bjs-powered-by {
  left: 0 !important;
  bottom: 0 !important;
  right: unset !important;
}

.djs-palette {
  left: 0 !important;
  top: 0 !important;
}

.djs-palette:not(.open) {
  display: none !important;
}

.djs-palette-toggle {
  display: none;
}

.dmn-drd-container {
  height: 100%;
}
</style>
